import { connect } from "react-redux"
import { IntlProvider } from "react-intl"
import locales from "./index"
import { captureException } from "../common/error"

// This connected intl provider is initial solution to get app to re-render when new locale is set
const onError = error => {
  if (
    error &&
    error.message &&
    (error.message.startsWith("[React Intl Error MISSING_TRANSLATION]") ||
      error.message.startsWith("[React Intl Error FORMAT_ERROR]"))
  ) {
    return
  } else {
    captureException(error)
  }
}

const mapStateToProps = state => {
  let locale = localStorage.getItem("locale") || navigator.language
  let messages = locales[locale] || locales[`${locale.substring(0, 2)}`] || {}

  if (state.selectedLocale) {
    const { value } = state.selectedLocale
    // for spanish only so far
    // if value of selected locale is es-us, set messages accordingly
    if (value === "es-us") {
      messages = locales["es"]
    }
    return { locale: value, messages: messages, onError }
  } else {
    return { locale: locale, messages: messages, onError }
  }
}
const ConnectedIntlProvider = connect(mapStateToProps)(IntlProvider)
export { ConnectedIntlProvider }



// WEBPACK FOOTER //
// ./assets/locales/ConnectedIntlProvider.js